module.exports = __webpack_public_path__ + "assets/img/1696.21ba38dc.png";